import React from 'react';

const CommunityAssessment = () => {
  return (
    <section id="community-assessment" className="community-assessment">
      <div className="container">
        <div className="assessment-content">
          <div className="assessment-text">
            <h2>Building Communities Together</h2>
            <p className="lead-text">
              Do you believe your community could benefit from a place like ours?
            </p>
            <p>
              Give us a call, and we will be happy to assess your community's needs
              to help keep your family close.
            </p>
            <div className="assessment-buttons">
              <button className="btn-primary">
                Contact Us for Assessment
              </button>
              <button className="btn-secondary" onClick={() => {
                const element = document.getElementById('booking');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}>
                Schedule a Visit
              </button>
            </div>
          </div>
          <div className="assessment-image">
            <img
              src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
              alt="Community caring - families staying close"
              className="assessment-main-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CommunityAssessment;